import { render } from "./LadTable.vue?vue&type=template&id=24c5d03c"
import script from "./LadTable.vue?vue&type=script&lang=js"
export * from "./LadTable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__